import React, { useState } from "react";
import { motion } from "framer-motion";
import { Outlet } from "react-router-dom";

import Sidebar from "./Sidebar";
import Header from "./Header";
import AIMentor from "./AIMentor";
import { useAuth } from "../context/AuthContext";

const Layout = () => {
  const { user } = useAuth();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex bg-gray-50 min-h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      {/* Main content area */}
      <motion.div
        animate={{
          marginLeft: collapsed ? "80px" : "260px",
        }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="flex-1 flex flex-col relative z-0"
      >
        <Header />

        {/* ✅ React Router v6 render point */}
        <main className="flex-1 p-6 overflow-y-auto z-10">
          <Outlet />
        </main>

        {/* ✅ Persistent AI Mentor assistant (Pro only UI) */}
        <AIMentor />
      </motion.div>
    </div>
  );
};

export default Layout;
